import { Primitive } from '../../../types/blocks/Primitive';

const UserBlock: Primitive = {
  name: 'UserBlock',
  friendlyName: 'User',
  isInput: false,
  isPrimitive: true,
  isAvailableInEditor: true,
  tags: ['Other'],
  properties: {
    user: {
      type: 'User',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default UserBlock;
